import OapStories from './code/Scripts/components/oap-stories.vue';
import OapStoriesCircleLink from './code/Scripts/components/oap-stories-circle-link';

export default {
  components: {
    OapStories,
    OapStoriesCircleLink,
  },
};
